import { FullScreenError, FullScreenSpinner } from 'components/FullScreen';
import BreadcrumbLayout from 'components/layout/BreadcrumbLayout';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useGetOrganisation } from 'api';
import ManageUnitsForm from './ManageUnitsForm';

const ManageUnits = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const locationState: any = state;

  const hasOrgId = !!locationState?.organisationId;
  const { status, data: organisation } = useGetOrganisation(
    locationState?.organisationId,
    { enabled: hasOrgId },
  );

  if (hasOrgId && status === 'pending') {
    return <FullScreenSpinner message={t('ui.event-management.loading')} />;
  }
  if (status === 'error') {
    return (
      <FullScreenError
        message={t('ui.event-management.organisations.error-loading')}
      />
    );
  }

  return (
    <BreadcrumbLayout
      titleKey="ui.event-management.title.units"
      activeTextKey="ui.event-management.title.manage-units"
      crumbs={{
        '/': t('ui.event-management.dashboard.home.title'),
        '/account': t('ui.event-management.my-account.title'),
      }}
      headingKey="ui.event-management.title.manage-units"
    >
      <ManageUnitsForm
        initialOrganisation={organisation}
        initialPractitionerId={locationState?.practitionerId}
      />
    </BreadcrumbLayout>
  );
};

export default ManageUnits;
